import AjaxAction from "./AjaxAction";
import AjaxForm from "./AjaxForm";
import AssetUpdates from "./AssetUpdates";
import Charts from "./Charts";
import DateShortcuts from "./DateShortcuts";
import DisableOnClick from "./DisableOnClick";
import ExpenseCategories from "./ExpenseCategories";
import ExpenseWizard from "./ExpenseWizard";
import LocationMap from "./LocationMap";
import Modal from "./Modal";
import MobileNavigation from "./MobileNavigation";
import Pjax from "./Pjax";
import PaymentStatusQuickEdit from "./PaymentStatusQuickEdit";
import PushNotifications from "./PushNotifications";
import Sidebar from "./Sidebar";
import StickyFormActions from "./StickyFormActions";
import TaskBoard from "./TaskBoard";
import TaskForm from "./TaskForm";

export default {
    init() {
        AjaxAction.init();
        AjaxForm.init();
        AssetUpdates.init();
        Charts.init();
        DateShortcuts.init();
        DisableOnClick.init();
        ExpenseCategories.init();
        ExpenseWizard.init();
        LocationMap.init();
        Modal.init();
        MobileNavigation.init();
        Pjax.init();
        PaymentStatusQuickEdit.init();
        PushNotifications.init();
        Sidebar.init();
        StickyFormActions.init();
        TaskBoard.init();
        TaskForm.init();
    },
};
